import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { Case } from '../_appCommon/base/Case';

@Injectable({providedIn: 'root'})
export class CaseWizardService
{
  private _onNextStep: Subject<void> = new Subject();
  private _onPreviousStep: Subject<void> = new Subject();

  private _currentCase: Case;
  public confirmCase: boolean = false;
  public caseStageId: number;
  public urlPDF: string = '';

  constructor()
  {

  }

  public getCurrentCase(): Case
  {
    if(!this._currentCase)
    {
      this._currentCase = JSON.parse(localStorage.getItem('newCaseTempData'));
    }

    return this._currentCase;
  }

  public updateCurrentCaseInfo(values: any): void
  {
    this._currentCase = Object.assign(this._currentCase ?? {}, values);
  }

  public setCurrentCaseInfo(currentCase: Case): void
  {
    this._currentCase = currentCase;
    this.updateNewCaseTempData(this._currentCase);
  }

  public updateNewCaseTempData(caseTemp: any = {}): void
  {
    let tempData = JSON.parse(localStorage.getItem('newCaseTempData')) ?? {};

    if(caseTemp)
    {
      tempData = Object.assign(tempData, caseTemp);
      localStorage.setItem('newCaseTempData', JSON.stringify(tempData));
    }
  }

  public onGoNextStep(): void
  {
    this._onNextStep.next();
  }

  public onGoPreviousStep(): void
  {
    this._onPreviousStep.next();
  }

  public getOnNextStep(): Observable<any>
  {
    return this._onNextStep.asObservable();
  }

  public getOnPreviousStep(): Observable<any>
  {
    return this._onPreviousStep.asObservable();
  }
}

